import script from "./DeliveryChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryChart.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryChart.vue?vue&type=style&index=0&id=369b937e&lang=css"

const __exports__ = script;

export default __exports__